<script lang="ts">
  import SaveButton from "$app/Pages/Signup/SaveButton.svelte"
  import UserForm from "./UserForm.svelte"
  import Honeybadger from "$app/utils/honeybadger"
  import { catchError, toast, xhr } from "$app/utils"

  let { recaptcha_site_key_v3 }: { recaptcha_site_key_v3: string } = $props()

  let saving = $state(false)
  let userForm = $state<UserForm>(null)
  let errors: Record<string, any> = $state({})

  async function handleSubmit(): Promise<void> {
    saving = true
    let captcha_token: string = ""

    try {
      captcha_token = await window.grecaptcha.execute(recaptcha_site_key_v3, {
        action: "signup"
      })
    } catch (e: any) {
      alert("There was a captcha error. Please try again.")
      Honeybadger.notify(e)
      saving = false
      return
    }

    const data = { user: userForm.getData(), selected_plan_id: "free" }

    const [error, resp] = await catchError(
      xhr.post("/signup", {
        ...data,
        "g-recaptcha-response-data": captcha_token
      })
    )
    if (error) {
      errors = error?.response?.data?.errors || {}
      saving = false
      toast("There are some errors. Please verify and try again.", "error")
      return
    }

    errors = {}
    saving = false
    if (resp.data?.redirection_path) {
      toast("Thank you for signing up!", "success")
      window.location.href = resp.data.redirection_path
    }
  }
</script>

<div class="bg-gray-50 py-2 shadow">
  <div class="px-6 py-3">
    <UserForm bind:this={userForm} {errors} />
  </div>

  <div class="px-6 py-3">
    <SaveButton bind:saving onclick={handleSubmit} />
  </div>
</div>
